import { useEffect, useState } from "react";
import { AppMetaInfo } from "../contexts/app.meta.slg";

export const useAppMeta = () => {
    const [meta, setMeta] = useState<AppMetaInfo | null>(null);

    useEffect(() => {
        AppMetaInfo.Instance().then(setMeta);
    }, []);
    return meta;
}